const L = require('leaflet');
const m = require('mithril');

L.Control.MithrilControl = L.Control.extend({
  onAdd: function(map) {
    // Create a div to hold the control
    this._div = L.DomUtil.create('div', 'mithril-control');
    // Prevent map interactions when clicking on the control
    L.DomEvent.disableClickPropagation(this._div);
    // Optional: disable scroll propagation
    L.DomEvent.disableScrollPropagation(this._div);
    return this._div;
  },

  onRemove: function(map) {
    // Cleanup when the control is removed
    if (this._mithrilComponent) {
      m.mount(this._div, null); // Unmount the Mithril component
    }
  },

  mountMithrilComponent: function(mithrilComponent, data) {
    // Store the Mithril component for later updates or removal
    this._mithrilComponent = {
      view: () => m(mithrilComponent, data)
    };
    m.mount(this._div, this._mithrilComponent);
  }
});

module.exports = L.Control.MithrilControl;
